import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

export type ListAppearance = 'table' | 'list';

export interface AppearanceOption {
  value: ListAppearance;
  icon: string;
}

interface Props {
  currentValue: ListAppearance;
  onSelect: (value: ListAppearance) => void;
}

const options: AppearanceOption[] = [
  { value: 'table', icon: '⊞' },
  { value: 'list', icon: '☰' },
];

const AppearanceDropdown: React.FC<Props> = ({ currentValue, onSelect }) => {
  const {t} = useTranslation()
  const handleToggle = () => {
    onSelect('list' === currentValue ? 'table' : 'list')
  }
    
  const selectedOption = options.find(opt => opt.value === currentValue)
  return (
    <div className="dossier-header-container">
      <button 
        type="button" 
        onClick={handleToggle}
        className="viewmode-toggle-btn"
        title={t('common.change-view-mode')}
      >
        {selectedOption && `${selectedOption.icon}`}
      </button>
    </div>
  );
};

export default AppearanceDropdown
